module.exports = __webpack_public_path__ + "static/media/equipodocente.8573e3db.jpg";